import { Box } from '@mui/material';

export const HighlightedText = ({ text, searchQuery }: { text: string; searchQuery: string }) => {
  if (!searchQuery.trim()) {
    return <>{text}</>;
  }

  const escapedQuery = [...searchQuery].map(char => (/[.*+?^${}()|[\]\\]/.test(char) ? `\\${char}` : char)).join('');
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <Box
            key={`${index}-${part}`}
            component='span'
            sx={theme => ({
              backgroundColor: theme.palette.highlight.main,
              color: theme.palette.highlight.contrastText,
              fontWeight: 'bold',
              padding: '0 1px',
            })}
          >
            {part}
          </Box>
        ) : (
          part
        )
      )}
    </>
  );
};
